import * as types from "./actionTypes";

export function dispatchActionData(type, data) {
  return { type: type, data: data };
}
//SET Submitted Assets information
export function setSubmittedAssetsInformation(data) {
  return function (dispatch) {
    dispatch(dispatchActionData(types.SET_SUBMITTED_ASSETS, data));
  };
}
//RESET Submitted Assets information
export function resetSubmittedAssets(data) {
  return function (dispatch) {
    dispatch(dispatchActionData(types.RESET_SUBMITTED_ASSETS, data));
  };
}
